module.exports = __webpack_public_path__ + "68461ca5187cd2c6af08786467085f2b.png";